var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartAccent600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5066 3.60999C19.9959 3.099 19.3894 2.69364 18.722 2.41708C18.0545 2.14052 17.3391 1.99817 16.6166 1.99817C15.8941 1.99817 15.1787 2.14052 14.5113 2.41708C13.8438 2.69364 13.2374 3.099 12.7266 3.60999L11.6666 4.66999L10.6066 3.60999C9.57493 2.5783 8.17566 1.9987 6.71662 1.9987C5.25759 1.9987 3.85831 2.5783 2.82662 3.60999C1.79493 4.64169 1.21533 6.04096 1.21533 7.49999C1.21533 8.95903 1.79493 10.3583 2.82662 11.39L3.88662 12.45L11.6666 20.23L19.4466 12.45L20.5066 11.39C21.0176 10.8792 21.423 10.2728 21.6995 9.60535C21.9761 8.93789 22.1184 8.22248 22.1184 7.49999C22.1184 6.77751 21.9761 6.0621 21.6995 5.39464C21.423 4.72718 21.0176 4.12075 20.5066 3.60999V3.60999Z",
    stroke: "#648CE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAccent600);
export default __webpack_public_path__ + "static/media/heart-accent600.da0087e3f9e270b0e47651e53efd2af3.svg";
export { ForwardRef as ReactComponent };